import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import api from '../utils/api'

interface Grade {
  id: number
  enrollment_id: number
  score: number
  grade: string
  completion_status: string
  completed_at: string
  course_title: string
  instructor: string
  credits: number
  year: number
  season: string
}

const MyGrades = () => {
  const [grades, setGrades] = useState<Grade[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadGrades()
  }, [])

  const loadGrades = async () => {
    try {
      const response = await api.get('/grades/my')
      setGrades(response.data)
    } catch (error) {
      console.error('성적 로드 오류:', error)
    } finally {
      setLoading(false)
    }
  }

  const downloadCertificate = async (enrollmentId: number) => {
    try {
      const response = await api.get(`/certificates/${enrollmentId}`, {
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `이수증명서_${enrollmentId}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error: any) {
      alert(error.response?.data?.error || '증명서 다운로드에 실패했습니다.')
    }
  }

  if (loading) {
    return <div className="container"><div className="loading">로딩 중...</div></div>
  }

  return (
    <div className="container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ margin: 0 }}>내 성적</h1>
        {grades.length > 0 && (
          <Link 
            to="/certificate" 
            className="btn btn-primary"
            style={{ padding: '10px 20px', fontSize: '14px' }}
          >
            📄 전체 증명서 다운로드
          </Link>
        )}
      </div>
      
      {grades.length === 0 ? (
        <div className="card">
          <p style={{ textAlign: 'center', color: '#666' }}>성적 내역이 없습니다.</p>
        </div>
      ) : (
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>강좌명</th>
                <th>교수명</th>
                <th>학년도/계절</th>
                <th>학점</th>
                <th>점수</th>
                <th>등급</th>
                <th>이수상태</th>
                <th>작업</th>
              </tr>
            </thead>
            <tbody>
              {grades.map(grade => (
                <tr key={grade.id}>
                  <td>{grade.course_title}</td>
                  <td>{grade.instructor}</td>
                  <td>{grade.year}년 {grade.season}</td>
                  <td>{grade.credits}학점</td>
                  <td>{grade.score || '-'}</td>
                  <td>{grade.grade || '-'}</td>
                  <td>
                    <span className={`btn ${grade.completion_status === 'completed' ? 'btn-success' : 'btn-secondary'}`} style={{ padding: '5px 10px', fontSize: '12px' }}>
                      {grade.completion_status === 'completed' ? '이수완료' : '미이수'}
                    </span>
                  </td>
                  <td>
                    {grade.completion_status === 'completed' && (
                      <button 
                        onClick={() => downloadCertificate(grade.enrollment_id)}
                        className="btn btn-primary"
                        style={{ padding: '5px 10px', fontSize: '12px' }}
                      >
                        증명서 다운로드
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default MyGrades
